import { render, staticRenderFns } from "./OpenResult.vue?vue&type=template&id=4e42fcdf&scoped=true&"
import script from "./OpenResult.vue?vue&type=script&lang=js&"
export * from "./OpenResult.vue?vue&type=script&lang=js&"
import style0 from "./OpenResult.vue?vue&type=style&index=0&id=4e42fcdf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42fcdf",
  null
  
)

export default component.exports